import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import useOperations from './useOperations';

const useSingleOperation = () => {
  const { id: routeId } = useParams();
  const { singleItem, loading, facilityTypes, statuses } = useOperations(
    false,
    false,
  );

  const viewItem = useMemo(
    () => ({
      ...singleItem,
      id: singleItem?.id || routeId,
    }),
    [singleItem, routeId],
  );

  return {
    singleItem: viewItem,
    loading,
    facilityTypes,
    statuses,
  };
};

export default useSingleOperation;
